import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

const DEFAULT_IMG_DESKTOP = "/images/activation/empty-desktop.svg";
const DEFAULT_IMG_MOBILE = "/images/activation/empty-mobile.svg";
export const GRANULARITY_LIST = {
    [GranularityNames.WEEKLY]: "activation.home.header.granularity.weekly",
    [GranularityNames.MONTHLY]: "activation.home.header.granularity.monthly",
};

const OFFSET_TOP_MOBILE = 56;

const LINE_WIDTH_1 = "25%";
const LINE_WIDTH = "80%";

const LINE_HEIGHT = 40;
const LINE_HEIGHT_1 = 20;

const SQUARE_HEIGHT = "90px";
const SQUARE_WIDTH = "110px";

const SQUARE_HEIGHT_1 = "110px";
const SQUARE_WIDTH_1 = "120px";

export const ONE = 1;
